import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes'

/**
 * Lumbung PrimeVue preset, themed with the tokens ported from
 * `design/web/crm.html` (see `design-tokens/tokens.css` + ADR-0002 in the
 * knowledge-base vault for why that file, of all things, is the source of
 * truth for colors here).
 *
 * Scope: we remap PrimeVue's `primary` semantic scale to our brand teal,
 * anchoring 600 = our light-mode `--primary` (#146B5C) and 300 = our
 * dark-mode `--primary` (#6FD8C4) so PrimeVue's own light/dark palette
 * selection lines up with the exact values the mockup uses at the tones
 * that matter most (buttons, links, focus rings, checked states).
 *
 * We deliberately do NOT remap PrimeVue's internal neutral/surface ramp —
 * the app shell's own chrome (sidebar/topbar/content backgrounds, spacing,
 * radius, elevation, fonts) is styled directly from tokens.css via plain
 * CSS custom properties, while PrimeVue's own components keep Aura's
 * well-tested neutral grays, which read fine next to a single teal accent.
 * Revisit with a full surface-ramp override if a future component-heavy
 * screen (MS-2+) needs pixel-perfect parity with the mockup's grays.
 */
export const lumbungPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eefaf6',
      100: '#d3f3e8',
      200: '#9ff2e0', // == --primary-container (light)
      300: '#6fd8c4', // == --primary (dark mode)
      400: '#3dbba2',
      500: '#1d8873',
      600: '#146b5c', // == --primary (light mode)
      700: '#0f5449',
      800: '#0b4037',
      900: '#082d27',
      950: '#04211c',
    },
  },
})

export const primevueThemeConfig = {
  preset: lumbungPreset,
  options: {
    // Same attribute selector tokens.css and stores/ui.ts key off — one
    // source of truth for light/dark, applied to <html data-theme="...">.
    darkModeSelector: '[data-theme="dark"]',
    cssLayer: false,
  },
}
